module.exports = __webpack_public_path__ + "static/media/Harish Kankanala.6a76569e.png";